import { Fragment } from 'react'

import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'

import Greet from './components/Greet'

const App = () => {
  return (
    <Fragment>
      <Greet />
    </Fragment>
  )
}

export default App
